import { ersActionTypes as actions } from "./ers.actions";

export const ersReducer = (state, { type, payload }) => {
  switch (type) {
    case actions.ERS_DATA:
      if (payload.error) {
        return {
          ...state,
          error: payload.error,
          // Still update data with empty array for the slug to prevent future fetch attempts
          data: payload.slug ? { ...state.data, [payload.slug]: [] } : state.data,
        };
      }
      return {
        ...state,
        error: null,
        data: { ...state.data, [payload.slug]: payload.data },
      };
    default:
      return state;
  }
};
